import AppImage from '@/components/ui/AppImage';
import Link from 'next/link';
import homepageTranslations from '@/lib/homepageTranslations.json';

interface HeroSectionProps {
  currentLang?: 'sl' | 'en';
}

export default function HeroSection({ currentLang = 'sl' }: HeroSectionProps) {
  const lang = currentLang === 'en' ? 'en' : 'sl';
  const content = {
    headline: homepageTranslations.hero.headline[lang],
    subheadline: homepageTranslations.hero.subheadline[lang],
    ctaPrimary: homepageTranslations.hero.ctaPrimary[lang],
    ctaSecondary: homepageTranslations.hero.ctaSecondary[lang],
  };

  return (
    <section className="relative min-h-screen flex flex-col justify-end p-6 md:p-10 pt-40 pb-20">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <AppImage
          src="https://images.unsplash.com/photo-1702495464926-0085637df194"
          alt="Beekeeper working with beehive in golden hour lighting, showing hands holding honeycomb frame with bees"
          className="w-full h-full object-cover"
          priority
        />

        <div className="absolute inset-0 bg-black/40"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto w-full">
        <h1 className="text-hero text-white mb-6 animate-slide-up">{content.headline}</h1>
        <p className="text-xl md:text-2xl text-white/90 mb-12 max-w-2xl animate-fade-in">
          {content.subheadline}
        </p>

        {/* CTAs */}
        <div className="flex flex-col sm:flex-row gap-4 animate-fade-in">
          <Link href="/products" className="btn-primary">
            {content.ctaPrimary}
          </Link>
          <a
            href="#about"
            className="btn-secondary bg-white/10 backdrop-blur-md border-white/20 text-white hover:bg-white/20"
          >
            {content.ctaSecondary}
          </a>
        </div>
      </div>

      {/* Honey Drip SVG Animation */}
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-16 h-32 z-20 animate-honey-drip">
        <svg viewBox="0 0 64 128" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M32 0 C32 0, 20 40, 20 60 C20 80, 25 100, 32 100 C39 100, 44 80, 44 60 C44 40, 32 0, 32 0 Z"
            fill="#F59E0B"
            opacity="0.8"
          />
        </svg>
      </div>
    </section>
  );
}
